import React from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import Link from '@material-ui/core/Link';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DoneIcon from '@material-ui/icons/Done';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import { stores } from '../store';

const useStyles = makeStyles(theme => ({
	button_wrapper: {
		position: 'relative',
		top: '25px',
		paddingBottom: '35px',
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'row',
		alignItems: 'baseline',
		marginRight: '20px',
		'& .MuiButton-label': {
			color: '#007DBA',
		},
		'& .MuiButton-text': { padding: '6px 16px !important' },
	},
	cookie_banner: {
		margin: '10px 25px !important',
		gap: '14%',
	},
	agree_button: {
		marginTop: '0px !important',	
		'& :hover': { 
			backgroundColor: '#007DBA',
			color: 'white',
			transition:'none',
		 },
		 '& :hover *' : {		
			color: 'white',
		}
	},	
	decline_button: {
		marginTop: '0px !important',		
		'& :hover': { 
			backgroundColor: '#007DBA',
			color: 'white',
			transition:'none',
		 },
		 '& :hover *' : {
			color: 'white',
		}
	},
	policy_text: {
		marginTop: '6px',
		width: '100%',
		color: '#CFDBE5',
	},
}));

const CookiePolicy = () => {
	const classes = useStyles();
	const user = React.useContext(stores.context.user);
	let keyvalue: boolean = true;
	if (Cookies.get('cookieconsent')) {
		keyvalue = false;
	}
	return keyvalue ? (
		<CookieConsent
			buttonText={
				<Button startIcon={<DoneIcon />}>
					Yes, I agree
				</Button>
			}
			buttonClasses={classes.agree_button}
			buttonStyle={{
				color: '#009FDF',
				textTransform: 'none',
				margin: '0px !important',
				padding: '0px !important',
				backgroundColor: 'transparent',
				'& .MuiButton-text': { margin: '0px !important', padding: '0px !important' },
			}}
			onAccept={() => {
				Cookies.set('cookieconsent', 'true', { expires: 7 });
			}}
			enableDeclineButton
			declineButtonClasses={classes.decline_button}
			declineButtonText={
				<Button startIcon={<SettingsOutlinedIcon />}>
					No, take me to settings
				</Button>
			}
			onDecline={() => {
				Cookies.set('cookieconsent', 'false', { expires: 7 });
				user.login();
				window.location.href = '/about';
			}}
			setDeclineCookie={true}
			declineButtonStyle={{
				color: '#009FDF',
				textTransform: 'none',
				margin: '0px !important',
				padding: '0px !important',
				backgroundColor: 'transparent',
				'& .MuiButton-text': { margin: '0px !important', padding: '0px !important' },
			}}
			buttonWrapperClasses={classes.button_wrapper}
			contentClasses={classes.cookie_banner}
			flipButtons={true}
			style={{ 
				backgroundColor: '#002855',
				zIndex: 10000, 
				display: 'flex', 
				top: '64px', 
				height: 'fit-content' 
			}}
		>
			<div style={{ fontSize: '1.2rem', marginTop: '4px' }}>Let us know you agree to cookies</div>
			<div className={classes.policy_text}>
				We use{' '}
				<Link
					href="https://www.mitie.com/legal/cookie-policy/"
					target="_blank"
					style={{ color: '#009FDF', padding: 0 }}
				>
					cookies
				</Link>{' '}
				to give you the best online experience. Please let us know if you agree to all of these cookies
			</div>
		</CookieConsent>
	) : (
		<></>
	);
};

export default CookiePolicy;
